import BeneficiaryInviteListComponent from 'components/Admin/BeneficiaryInviteListComponent/BeneficiaryInviteListComponent';
import BeneficiaryListComponent from 'components/Admin/BeneficiaryListComponent/BeneficiaryListComponent';
import ContainerComponent from 'components/Tool/ContainerComponent/ContainerComponent';
import Footer from 'pages/Client/Footer/Footer';
import Header from 'pages/Client/Header/Header';
import './Beneficiaries.css';

function Beneficiaries() {
  return (
    <div className="beneficiaries layout-full-height">
      <Header />

      <ContainerComponent className="layout-main-content">
        <>
          <div className="beneficiaries-header">
            <h1>Administration</h1>
            <p>Manage messages and delivery settings for your assigned accounts</p>
          </div>

          <BeneficiaryInviteListComponent />

          <BeneficiaryListComponent />
        </>
      </ContainerComponent>

      <Footer />
    </div>
  );
}

export default Beneficiaries;
